<template>
  <aside class="box-payment-methods">
    <h5 class="box-payment-methods__title">{{ $t('pages.checkout.payment_methods_title') }}</h5>
    <div class="box-payment-methods__cards" v-if="showIDeal">
      <img src="@/assets/event_owner/default/icons/ideal.svg" width="50" alt="iDEAL">
    </div>
    <div class="box-payment-methods__cards" v-if="showMercadoPago">
      <img src="@/assets/payments/mercado-pago.svg" width="150" alt="Mercado Pago">
    </div>
     <div class="box-payment-methods__cards" v-if="showP24">
      <img src="@/assets/payments/przelewy24.svg" width="100" alt="P24">
    </div>
    <div class="box-payment-methods__cards" v-if="showStripeCards">
      <img src="@/assets/payments/american-express.svg" height="20" alt="American Express" class="ml-0">
      <img src="@/assets/payments/diners.svg" height="20" alt="Diners">
      <img src="@/assets/payments/discover.svg" height="20" alt="Discover">
      <img src="@/assets/payments/jcb.svg" height="20" alt="JCB" class="mr-0">
      <img src="@/assets/payments/master-card.svg" height="20" alt="MasterCard" class="ml-0">
      <img src="@/assets/payments/visa.svg" height="20" alt="Visa">
      <img src="@/assets/payments/visa-electron.svg" height="20" alt="Visa Electron">
      <img src="@/assets/payments/postepay.svg" height="20" alt="PostePay">
      <div class="mt-3">
        <a class="box-payment-methods__stripe-link"
           :href="`https://stripe.com/it/payments/features#${isStipeCards ? 'cards': 'bank-redirects'}`"
           target="_blank">
          <Icon name="stripe" width="137"/>
        </a>
      </div>
    </div>
  </aside>
</template>

<script>

import {PAYMENT_METHOD_CARD, PAYMENT_METHOD_IDEAL, PAYMENT_METHOD_MERCADO_PAGO, PAYMENT_METHOD_P24} from "@/consts.js"

export default {


  props: {
    selectedPaymentMethod: {
      type: String,
      required: false
    },
    paymentMethods: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    isStipeCards() {
      return this.selectedPaymentMethod === PAYMENT_METHOD_CARD
    },
    showStripeCards() {
      return this.selectedPaymentMethod === PAYMENT_METHOD_CARD || this.paymentMethods.includes(PAYMENT_METHOD_CARD) || this.paymentMethods.includes('card')
    },
    showIDeal() {
      return this.selectedPaymentMethod === PAYMENT_METHOD_IDEAL || this.paymentMethods.includes(PAYMENT_METHOD_IDEAL)
    },
    showMercadoPago() {
      return this.selectedPaymentMethod === PAYMENT_METHOD_MERCADO_PAGO || this.paymentMethods.includes(PAYMENT_METHOD_MERCADO_PAGO)
    },
    showP24() {
      return this.selectedPaymentMethod === PAYMENT_METHOD_P24 || this.paymentMethods.includes(PAYMENT_METHOD_P24)
    },
  }
}
</script>
